import React from 'react';
import { useParams } from 'react-router-dom';
import { lawyersData } from '../data/lawyers';
import efrenPhoto from '../assets/images/Efren/seño efren.jpg';
import efrenLogo from '../assets/images/Efren/logo.jpg';
import gesopsPhoto from '../assets/images/GesOps/Luisa.jpeg';
import gesopsLogo from '../assets/logos/HEADERNAVBAR.png';
import jesusPhoto from '../assets/images/JesusX/señor jesus.jpeg';
import jesusLogo from '../assets/images/JesusX/logo.png';
import therapyPhoto from '../assets/images/Therapy Works/señora therapy.jpg';
import therapyLogo from '../assets/images/Therapy Works/logo.png';

const LawyerProfilePage = () => {
  const { slug } = useParams();
  
  // Buscar el abogado por slug en todos los estados
  let lawyer = null;
  for (const state in lawyersData) {
    const found = lawyersData[state].find(l => l.slug === slug);
    if (found) {
      lawyer = found;
      break;
    }
  }

  if (!lawyer) {
    return (
      <div className="lawyer-profile-error">
        <div className="container">
          <h1>Abogado no encontrado</h1>
          <p>El perfil que buscas no existe o ha sido removido.</p>
        </div>
      </div>
    );
  }

  // Resolver imágenes
  const getImage = (imageId) => {
    if (imageId === 'efren-photo') return efrenPhoto;
    if (imageId === 'efren-logo') return efrenLogo;
    if (imageId === 'gesops-photo') return gesopsPhoto;
    if (imageId === 'gesops-logo') return gesopsLogo;
    if (imageId === 'jesus-photo') return jesusPhoto;
    if (imageId === 'jesus-logo') return jesusLogo;
    if (imageId === 'therapy-photo') return therapyPhoto;
    if (imageId === 'therapy-logo') return therapyLogo;
    return imageId;
  };

  // Limpiar número de teléfono para enlaces tel:
  const cleanPhoneNumber = (phone) => {
    if (!phone) return '';
    return phone.replace(/[\s\(\)\-]/g, '');
  };

  // Descripciones de servicios de Therapy Works
  const therapyServiceDescriptions = {
    'Terapia individual': 'Atención personalizada enfocada en tu bienestar emocional, crecimiento personal y salud mental.',
    'Terapia para Adolescentes': 'Un espacio seguro diseñado para ayudar a los adolescentes a manejar emociones, cambios, relaciones y situaciones que impactan su bienestar.',
    'Terapia Infantil': 'Apoyo especializado para niños, enfocado en fortalecer su desarrollo emocional, conductual y social en un ambiente seguro y comprensivo.',
    'Terapia de Pareja': 'Espacio orientado a fortalecer la comunicación, resolver conflictos y construir relaciones más saludables y equilibradas.',
    'Terapia Familiar': 'Fortalecemos relaciones familiares promoviendo comunicación, comprensión y bienestar colectivo.',
    'Evaluaciones Clínicas para Inmigración': 'Evaluaciones psicológicas profesionales para apoyar procesos migratorios, realizadas con ética, sensibilidad y enfoque clínico.',
    'Evaluaciones de Abusos de Sustancias': 'Valoraciones profesionales enfocadas en comprender patrones de consumo y brindar recomendaciones adecuadas según cada situación.',
    'Conferencias y Talleres': 'Experiencias educativas diseñadas para inspirar, enseñar y promover el bienestar emocional.',
  };

  // Descripciones de servicios legales (para mostrar ayuda al usuario)
  const serviceDescriptions = {
    'Representación en Corte de Inmigración': 'Defensa profesional para evitar la deportación. Defendemos tu caso ante un juez de inmigración. Analizamos a fondo tu situación, preparamos estrategias legales sólidas y te acompañamos en cada audiencia para luchar por tu permanencia legal en EE.UU.',
    'Asilo Defensivo y Afirmativo': 'Protección ante persecución y peligro. Si has sufrido persecución o temes regresar a tu país, te ayudamos a solicitar asilo afirmativo (ante USCIS) o defensivo (en procesos de deportación), según tu caso. Recopilamos pruebas y documentos clave para fortalecer tu solicitud.',
    'Asilo Afirmativo y Defensivo': 'Protección ante persecución y peligro. Si has sufrido persecución o temes regresar a tu país, te ayudamos a solicitar asilo afirmativo (ante USCIS) o defensivo (en procesos de deportación), según tu caso. Recopilamos pruebas y documentos clave para fortalecer tu solicitud.',
    'Ajuste de Estatus / Green Card': 'Tu camino a la residencia permanente. ¿Eres elegible para ajustar tu estatus? Te asesoramos para obtener tu residencia legal sin salir del país. Nos encargamos del proceso de principio a fin para evitar errores y asegurar una aprobación rápida.',
    'Ajuste de Status': 'Tu camino a la residencia permanente. ¿Eres elegible para ajustar tu estatus? Te asesoramos para obtener tu residencia legal sin salir del país. Nos encargamos del proceso de principio a fin para evitar errores y asegurar una aprobación rápida.',
    'Visas Humanitarias (U, T, VAWA)': 'Protección legal para víctimas. Si sufriste abuso, violencia doméstica o fuiste víctima de un delito, puedes calificar para una visa humanitaria. Estas visas permiten solicitar residencia en el futuro. Nuestro equipo te acompaña con sensibilidad y eficacia.',
    'Visa de Prometido/a (K1)': 'Reunión familiar sin barreras. ¿Tienes planes de casarte con un ciudadano/a estadounidense? Te ayudamos a gestionar tu visa K1 para que entres legalmente al país, te cases y luego apliques a la residencia permanente.',
    'Visa K-1': 'Reunión familiar sin barreras. ¿Tienes planes de casarte con un ciudadano/a estadounidense? Te ayudamos a gestionar tu visa K1 para que entres legalmente al país, te cases y luego apliques a la residencia permanente.',
    'Apelaciones y Mociones de Reapertura': 'Segundas oportunidades legales. Si tu caso fue negado o cerrado, aún hay opciones. Presentamos apelaciones ante la Junta de Apelaciones de Inmigración (Board of Immigration Appeals en inglés "BIA") y mociones de reapertura si existen nuevas pruebas o errores procesales.',
    'Apelaciones': 'Segundas oportunidades legales. Si tu caso fue negado o cerrado, aún hay opciones. Presentamos apelaciones ante la Junta de Apelaciones de Inmigración (Board of Immigration Appeals en inglés "BIA") y mociones de reapertura si existen nuevas pruebas o errores procesales.',
    'Visas EB-2': 'Residencia por talento profesional. Si tienes estudios avanzados o habilidades excepcionales, puedes calificar para una visa EB-2, incluyendo procesos por interés nacional. Te guiamos en cada paso para que logres tu residencia permanente basada en tu carrera.',
    'Visa EB2': 'Residencia por talento profesional. Si tienes estudios avanzados o habilidades excepcionales, puedes calificar para una visa EB-2, incluyendo procesos por interés nacional. Te guiamos en cada paso para que logres tu residencia permanente basada en tu carrera.',
    'Removal Proceedings (corte)': 'Defensa profesional para evitar la deportación. Defendemos tu caso ante un juez de inmigración. Analizamos a fondo tu situación, preparamos estrategias legales sólidas y te acompañamos en cada audiencia para luchar por tu permanencia legal en EE.UU.',
    'Stay of Removal': 'Solicitud para detener temporalmente una orden de deportación mientras se revisa un caso o se presenta otra solicitud pendiente.',
    'Peticiones familiares': 'Trámites para que residentes o ciudadanos estadounidenses pidan a sus familiares (esposo/a, hijos, padres, etc.) para obtener un estatus legal.',
    'Parole in Place (PIP)': 'Beneficio especial para ciertos familiares de militares o veteranos que permite obtener permiso de permanencia y, en algunos casos, facilitar el ajuste de estatus.',
    'Waivers': 'Trámites para pedir al gobierno de EE. UU. que perdone ciertos problemas migratorios (como entradas irregulares o castigos) y así poder seguir con tu caso.'
  };

  // Colores específicos para cada abogado
  const isSolYJusticia = lawyer.slug === 'efren-marrero';
  const isGesOps = lawyer.slug === 'gesops-llc';
  const isJesus = lawyer.slug === 'jesus-rios-figueroa';
  const isTherapyWorks = lawyer.slug === 'therapy-works-counseling';
  const themeClass = isSolYJusticia ? 'sol-y-justicia-theme' : (isGesOps ? 'gesops-theme' : (isJesus ? 'jrios-theme' : (isTherapyWorks ? 'therapy-works-theme' : '')));

  return (
    <div className={`lawyer-profile-page ${themeClass}`}>
      {/* Hero Section */}
      <section className="profile-hero">
        <div className="container">
          <div className="profile-hero-content">
            <div className="profile-header">
              {lawyer.logo && (
                <div className="firm-logo">
                  <img src={getImage(lawyer.logo)} alt={lawyer.firmName || lawyer.name} />
                </div>
              )}
              <div className="profile-info">
                <h1 className="lawyer-name">{lawyer.name}</h1>
                {lawyer.firmName && (
                  <h2 className="firm-name">{lawyer.firmName}</h2>
                )}
                <p className="specialty">{lawyer.specialty}</p>
                {lawyer.isPremium && (
                  <span className="premium-badge">✨ Miembro Premium</span>
                )}
              </div>
            </div>
            
            {lawyer.photo && (
              <div className="profile-photo">
                <img src={getImage(lawyer.photo)} alt={lawyer.name} />
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Contact Bar */}
      <section className="contact-bar">
        <div className="container">
          <div className="contact-items">
            {isGesOps ? (
              <>
                <div className="contact-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                  </svg>
                  <a href={`https://wa.me/18049608133?text=Hola%2C+quisiera+m%C3%A1s+informaci%C3%B3n+sobre+los+servicios+de+GesOps`} target="_blank" rel="noopener noreferrer">
                    WhatsApp Directo: +1 (804) 960-8133
                  </a>
                </div>
                <div className="contact-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                  <a href={`tel:${lawyer.phoneSecondary}`}>Llamada Corporativa: {lawyer.phoneSecondary}</a>
                </div>
              </>
            ) : (
              <>
                <div className="contact-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                  <a href={`tel:${lawyer.phone}`}>{lawyer.phone}</a>
                </div>
                <div className="contact-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                  <a href={`mailto:${lawyer.email}`}>{lawyer.email}</a>
                </div>
                {lawyer.emailSecondary && (
                  <div className="contact-item">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                      <polyline points="22,6 12,13 2,6"/>
                    </svg>
                    <a href={`mailto:${lawyer.emailSecondary}`}>{lawyer.emailSecondary}</a>
                  </div>
                )}
                {lawyer.website && (
                  <div className="contact-item">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"/>
                      <line x1="2" y1="12" x2="22" y2="12"/>
                      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                    </svg>
                    <a href={lawyer.website} target="_blank" rel="noopener noreferrer">Sitio Web Oficial</a>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="profile-about">
        <div className="container">
          <div className="about-grid">
            <div className="about-content">
              <h2 className="section-title">
                {isGesOps ? 'Sobre Nosotros' : (isTherapyWorks ? '¿Quiénes Somos?' : 'Sobre el Abogado')}
              </h2>
              <div className="bio-text">
                {lawyer.bio && lawyer.bio.split('\\n\\n').map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
            </div>
            
            {lawyer.states && lawyer.states.length > 0 && (
              <div className="coverage-card">
                <h3>Cobertura de Estados</h3>
                {isGesOps && lawyer.states.length === 51 ? (
                  <div className="states-summary">
                    <div className="coverage-badge-large">
                      <span className="coverage-number">50</span>
                      <span className="coverage-text">estados</span>
                      <span className="coverage-plus">+</span>
                      <span className="coverage-pr">PR</span>
                    </div>
                    <p className="coverage-description">
                      Cobertura completa en todos los Estados Unidos y Puerto Rico
                    </p>
                  </div>
                ) : isTherapyWorks && lawyer.customCoverage ? (
                  <div className="custom-coverage">
                    <div className="coverage-section">
                      <h4 className="coverage-subtitle">EVALUACIONES:</h4>
                      <p className="coverage-info">Disponibles en todos los estados de EE.UU mas Puerto Rico, <strong>excepto Nuevo México</strong>.</p>
                    </div>
                    <div className="coverage-section">
                      <h4 className="coverage-subtitle">TERAPIA:</h4>
                      <p className="coverage-info"><strong>Oficinas Texas:</strong></p>
                      <div className="oficinas-list">
                        {lawyer.customCoverage.terapia.oficinas.map((oficina, index) => (
                          <div key={index} className="oficina-item">
                            <strong>{oficina.ciudad}:</strong> {oficina.direccion}
                          </div>
                        ))}
                      </div>
                      <p className="coverage-info online-therapy">
                        {lawyer.customCoverage.terapia.online}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="states-list">
                    {lawyer.states.map((state, index) => (
                      <span key={index} className="state-badge">{state}</span>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Services Section - GesOps con categorías */}
      {isGesOps && lawyer.serviceCategories ? (
        <section className="profile-services gesops-services">
          <div className="container">
            <h2 className="section-title">Categorías de Servicio</h2>
            {lawyer.serviceCategories.map((category, catIndex) => (
              <div key={catIndex} className="service-category-section">
                <h3 className="category-title">
                  <span className="category-icon">{category.icon}</span>
                  {category.name}
                </h3>
                <p className="category-description">{category.description}</p>
                
                {catIndex === 0 && (
                  <div className="services-grid">
                    <div className="service-card">
                      <div className="service-header">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                        <span className="service-title">Creación de perfil profesional</span>
                      </div>
                    </div>
                    <div className="service-card">
                      <div className="service-header">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                        <span className="service-title">Publicidad desde los canales de GesOps</span>
                      </div>
                    </div>
                    <div className="service-card">
                      <div className="service-header">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                        <span className="service-title">Enlace directo a WhatsApp</span>
                      </div>
                    </div>
                    <div className="service-card">
                      <div className="service-header">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                        <span className="service-title">Visibilidad dentro del directorio</span>
                      </div>
                    </div>
                    <div className="service-card">
                      <div className="service-header">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                        <span className="service-title">Posicionamiento de marca</span>
                      </div>
                    </div>
                  </div>
                )}
                
                {catIndex === 1 && (
                  <>
                    <div className="services-grid">
                      <div className="service-card">
                        <div className="service-header">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="20 6 9 17 4 12"/>
                          </svg>
                          <span className="service-title">Preparación administrativa de formularios</span>
                        </div>
                      </div>
                      <div className="service-card">
                        <div className="service-header">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="20 6 9 17 4 12"/>
                          </svg>
                          <span className="service-title">Organización y revisión documental</span>
                        </div>
                      </div>
                      <div className="service-card">
                        <div className="service-header">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="20 6 9 17 4 12"/>
                          </svg>
                          <span className="service-title">Gestión de contratos y follow-up</span>
                        </div>
                      </div>
                      <div className="service-card">
                        <div className="service-header">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="20 6 9 17 4 12"/>
                          </svg>
                          <span className="service-title">Coordinación de cartera y pagos</span>
                        </div>
                      </div>
                      <div className="service-card">
                        <div className="service-header">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="20 6 9 17 4 12"/>
                          </svg>
                          <span className="service-title">Soporte operativo del caso</span>
                        </div>
                      </div>
                    </div>
                    <p className="service-disclaimer">(GesOps no brinda asesoría legal ni contacto directo con clientes finales sin autorización del abogado.)</p>
                  </>
                )}
                
                {catIndex === 2 && (
                  <div className="services-grid">
                    <div className="service-card">
                      <div className="service-header">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                        <span className="service-title">Traducciones certificadas válidas para USCIS/DOJ</span>
                      </div>
                    </div>
                    <div className="service-card">
                      <div className="service-header">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                        <span className="service-title">Traducción de documentos personales y legales</span>
                      </div>
                    </div>
                    <div className="service-card">
                      <div className="service-header">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                        <span className="service-title">Traducción empresarial y técnica</span>
                      </div>
                    </div>
                    <div className="service-card">
                      <div className="service-header">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                        <span className="service-title">Entrega digital</span>
                      </div>
                    </div>
                    <div className="service-card">
                      <div className="service-header">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                        <span className="service-title">Certificado de traducción profesional</span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>
      ) : isTherapyWorks ? (
        // Sección especial de servicios para Therapy Works con dos categorías
        <section className="profile-services">
          <div className="container">
            {/* Primera sección: Nuestros Servicios */}
            <h2 className="section-title">Nuestros Servicios</h2>
            <div className="services-grid">
              {lawyer.services.map((service, index) => {
                const therapyDesc = therapyServiceDescriptions[service];
                return (
                  <div key={index} className="service-card">
                    <div className="service-header">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"/>
                        <polyline points="12 6 12 12 16 14"/>
                      </svg>
                      <span className="service-title">{service}</span>
                    </div>
                    {therapyDesc && (
                      <p className="service-description">{therapyDesc}</p>
                    )}
                  </div>
                );
              })}
            </div>

            {/* Segunda sección: Evaluaciones Clínicas para Inmigración */}
            {lawyer.immigrationServices && lawyer.immigrationServices.length > 0 && (
              <>
                <h2 className="section-title" style={{ marginTop: '60px' }}>Evaluaciones Clínicas para Inmigración</h2>
                <div className="immigration-services-grid">
                  {lawyer.immigrationServices.map((service, index) => (
                    <div key={index} className="immigration-service-item">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"/>
                        <polyline points="12 6 12 12 16 14"/>
                      </svg>
                      <span>{service}</span>
                    </div>
                  ))}
                </div>
              </>
            )}

            {lawyer.insurances && lawyer.insurances.length > 0 && (
              <>
                <h2 className="section-title" style={{ marginTop: '60px' }}>Seguros Aceptados</h2>
                <div className="immigration-services-grid">
                  {lawyer.insurances.map((insurance, index) => (
                    <div key={index} className="immigration-service-item">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                      </svg>
                      <span>{insurance}</span>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </section>
      ) : (
        lawyer.services && lawyer.services.length > 0 && (
          <section className="profile-services">
            <div className="container">
              <h2 className="section-title">Servicios Legales</h2>
              <div className="services-grid">
                {lawyer.services.map((service, index) => {
                  const description = serviceDescriptions[service];
                  return (
                    <div key={index} className="service-card">
                      <div className="service-header">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <polyline points="20 6 9 17 4 12"/>
                        </svg>
                        <span className="service-title">{service}</span>
                      </div>
                      {description && (
                        <p className="service-description">{description}</p>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </section>
        )
      )}

      {/* Social Media Section */}
      {lawyer.socialMedia && (
        <section className="profile-social">
          <div className="container">
            <h2 className="section-title">
              Síguenos en redes sociales
            </h2>
            <div className="social-links-profile">
              {lawyer.socialMedia.facebook && (
                <a href={lawyer.socialMedia.facebook} target="_blank" rel="noopener noreferrer" className="social-btn facebook">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                  Facebook
                </a>
              )}
              {lawyer.socialMedia.instagram && (
                <a href={lawyer.socialMedia.instagram} target="_blank" rel="noopener noreferrer" className="social-btn instagram">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                  </svg>
                  Instagram
                </a>
              )}
              {lawyer.socialMedia.tiktok && (
                <a href={lawyer.socialMedia.tiktok} target="_blank" rel="noopener noreferrer" className="social-btn tiktok">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
                  </svg>
                  TikTok
                </a>
              )}
              {lawyer.socialMedia.youtube && (
                <a href={lawyer.socialMedia.youtube} target="_blank" rel="noopener noreferrer" className="social-btn youtube">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                  </svg>
                  YouTube
                </a>
              )}
              {!isGesOps && lawyer.socialMedia.linkedin && (
                <a href={lawyer.socialMedia.linkedin} target="_blank" rel="noopener noreferrer" className="social-btn linkedin">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                  LinkedIn
                </a>
              )}
            </div>
          </div>
        </section>
      )}

      {/* CTA Section - Solo para abogados, no para GesOps */}
      {!isGesOps && (
        <section className="profile-cta">
          <div className="container">
            <div className="cta-content">
              <h2>{isTherapyWorks ? '¿Necesitas Asesoría?' : '¿Necesitas Asesoría Legal?'}</h2>
              <p>Contacta directamente con {lawyer.firmName || lawyer.name} para una consulta</p>
              <div className="cta-buttons">
                <a href={`tel:${cleanPhoneNumber(lawyer.phone)}`} className="btn btn-primary-profile">
                  Llamar Ahora
                </a>
                <a href={`mailto:${lawyer.email}`} className="btn btn-secondary-profile">
                  Enviar Email
                </a>
                {lawyer.website && (
                  <a href={lawyer.website} target="_blank" rel="noopener noreferrer" className="btn btn-secondary-profile">
                    Visitar Sitio Web
                  </a>
                )}
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default LawyerProfilePage;
